import { useEffect } from "react";
import { usePatchPortfolioNonLifeInsuranceMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioNonLifeInsuranceMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { mapPortfolioToNonLifeInsuranceForm } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/mapPortfolioToNonLifeInsuranceForm";
import { getNonLifeInsuranceFormSchema } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormSchema";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditNonLifeInsuranceFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditNonLifeInsuranceForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditNonLifeInsuranceFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioNonLifeInsuranceMutation(portfolioId);

	const { form, onSubmit, leaveConfirmation } = useEditPortfolioForm({
		schema: getNonLifeInsuranceFormSchema(t),
		defaultValues: mapPortfolioToNonLifeInsuranceForm(portfolio),
		mutate,
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
		isPending,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending, leaveConfirmation };
};
